import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { IssueCertLayoutComponent } from './issue-cert-layout/issue-cert-layout.component';
import { AddCertificateComponent } from './add-certificate/add-certificate.component';
import { issueCertRouting } from './issuecertificate-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {  NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from "./ngb-date-fr-parser-formatter"
import { DealerPaymentGatewayComponent } from '../users/dealer-payment-gateway/dealer-payment-gateway.component';
import { NoScrollNumberDirective } from '../_helpers/no-scroll-number.directive';

@NgModule({
  declarations: [IssueCertLayoutComponent, AddCertificateComponent, DealerPaymentGatewayComponent
  ],
  providers: [{provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter}],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    issueCertRouting,
    NgbModule,
    NoScrollNumberDirective,
    // UsersModule
    // DealerPaymentGatewayComponent

  ],
  exports: [IssueCertLayoutComponent],
  bootstrap: [IssueCertLayoutComponent]
})
export class IssueCertificateModule {
}
